import React from 'react';
import {
  $BannerContent,
  $BannerTitle,
  $BannerFeatures,
  $ButtonContainer,
  $TryNowButton,
  $ReadDocumentationButton,
  $DemoContainer,
} from './AddressVerificationPromotionBanner.styled';

interface Props {
  onTryNow: () => void;
  onReadDocumentation: () => void;
  isRequestButtonDisabled?: boolean;
}

function AddressVerificationPromotionBannerContent({
  onTryNow,
  onReadDocumentation,
  isRequestButtonDisabled = false,
}: Props) {
  return (
    <>
      <$DemoContainer>
        <img
          src="/images/addressVerification/address-verification-demo-short.gif"
          alt="Address verification icon"
        />
      </$DemoContainer>
      <$BannerContent>
        <span className="new-service">NEW FEATURE</span>
        <$BannerTitle>Verify your customers addresses instantly</$BannerTitle>
        <$BannerFeatures>
          <li>Optimize the time to onboard users</li>
          <li>Increase conversion rates</li>
          <li>One integration, two verification methods</li>
        </$BannerFeatures>
        <$ButtonContainer>
          <$TryNowButton 
            onClick={() => !isRequestButtonDisabled && onTryNow()} 
            className={isRequestButtonDisabled ? 'disabled' : ''}
          >
            {isRequestButtonDisabled ? 'Request sent' : 'Request access'}
          </$TryNowButton>
          <$ReadDocumentationButton onClick={onReadDocumentation}>
            Learn more
          </$ReadDocumentationButton>
        </$ButtonContainer>
      </$BannerContent>
    </>
  );
}

export default AddressVerificationPromotionBannerContent;
